/***
 * 动作模型设计
 * --id--唯一标识
 * --plan_id--所属预案
 * --name--动作名称
 * --type--动作类型
 * --type_name--动作类型
 * --delay--延迟时间
 * --data--动作参数
 * --coordinate--坐标
 * --view--相机视角
 * --complete--是否完成
 * --params--特效
 *   --isUse--是否启用
 *   --type--特效类型
 *   --data--特效参数
 */

import * as effectsHelp from "./effects.js"
import PathAnimation from "../lib/PathAnimation"

let entityArr = [];
let primitiveArr = [];

//执行特效
export function do_effects(item, entity) {

    if (!item.params || !item.params.data || !item.params.data.isUse) {
        return;
    }
    var type = item.params.type;
    var data = item.params.data;
    if (type == "blinkEntity") {
        effectsHelp.blinkEntity(entity, data.duration);
        return;
    }

    if (type == "growEntity") {
        var positions = entity.polygon.hierarchy.getValue().positions;
        var speed = 1 / 60 / data.duration;
        speed = speed < 0.0001 ? 0.0001 : speed;
        effectsHelp.growEntityCom(entity, positions, speed, 0);
        return;
    }

    if (type == "comRoam") {
        effectsHelp.action_comRoam(entity, data.data, data.time);
        return;
    }

    if (type == "comHide") {
        effectsHelp.comHide(entity, data.duration);
        return;
    }
    if (type == "spreadEntity") {
        effectsHelp.spreadEntity(entity, data.tableData, data.isBig);
        return;
    }

    if (type == "multiRoam") {
        effectsHelp.multiRoam(entity, data.tableData);
        return;
    }

}

/********************************动作开始**********************************/

//视角书签--不带特效
export function action_sceneBookmark(item) {
    let view = item.view;
    let opts = {};
    opts.destination = Cesium.Cartesian3.fromDegrees(view.x, view.y, view.z); //经度、纬度、高度
    opts.orientation = {
        heading: Cesium.Math.toRadians(Cesium.defaultValue(view.heading, 0)), //绕垂直于地心的轴旋转
        pitch: Cesium.Math.toRadians(Cesium.defaultValue(view.pitch, -90)), //绕纬度线旋转
        roll: Cesium.Math.toRadians(Cesium.defaultValue(view.roll, 0)), //绕经度线旋转
    };

    opts.complete = function () {
        item.complete = true;
    };

    viewer.camera.flyTo(opts);
}


let growTypes = ["攻击箭头", "突击方向", "集结地", "钳击箭头", "分队战斗", "直线箭头"];
//通用标绘--添加
export function action_commonPlot(item) {
    item.complete = true;
    item.data.BQ = true;
    var entity = DBmap.plotUti.load(item.data.extType, item.data);
    entityArr.push(entity);

    entity.markName = item.name;
    entity.isAlreadyPlotflag = true; //已经存在了

    if (item.data && JSON.parse(item.data.styleAttr).formLine) {
        var lineOpt = {
            editPositions: JSON.stringify(entity.polygon.hierarchy.getValue().positions),
            styleAttr: JSON.stringify(JSON.parse(item.data.styleAttr).formLine),
        }
        DBmap.plotUti.append("线", entity, lineOpt);
    }
    entity.update = function (data) {
        item["name"] = data["name"] || item["name"];
        item["data"] = data["data"] || item["data"];
    };

    // if(entity['polygon']){
    //     var  material = new Cesium.PolyGradientMaterialProperty({
    //         isInner:false
    //     });

    //     console.log(material)
    //     entity['polygon'].material = material; 
    // }


    do_effects(item, entity);// 执行特效
    // if (item.data.extType && growTypes.includes(item.data.extType)) {
    //     growEntityCom(entity, entity.polygon.hierarchy.getValue().positions, 0.003, 0);
    //     return;
    // }
    // let roam = params.roam;
    // //特效对象
    // //type--特效类型
    // //data--特效参数
    // if (roam && roam.isUse && roam.data) {
    //     action_comRoam(entity, roam.data, roam.time)
    //     return;
    // }
    // blinkEntity(entity, 3);
}

//军事标绘--添加
export function action_militaryPlot(item) {
    item.complete = true;
    item.data.BQ = true;
    var entity = DBmap.plotUti.load(item.data.extType, item.data);
    entityArr.push(entity);

    entity.markName = item.name;
    entity.isAlreadyPlotflag = true; //已经存在了

    entity.update = function (data) {
        item["name"] = data["name"] || item["name"];
        item["data"] = data["data"] || item["data"];
    };

    do_effects(item, entity);// 执行特效
    //blinkEntity(entity,3);
    //growEntity(entity, entity["edit_positions"], 0.01, 0);
}

//添加通用漫游
export function action_comRoam(entity, positions, time) {
    var animation = new PathAnimation({
        entity: entity,
        positions: positions,
        speed: 100,
        sumTime: time,
        multiple: 1,
        height: 0,
        addHeight: 0,
        cameraType: "无",
        shadingType: "无",
        surface: true,
        cycle: false,
    });

    animation.start();
}

export function action_ignitionPoint(item) {
    item.complete = true;
    var entity = addParticleSystem(item.coordinate);
    return entity;
}

/********************************动作结束**********************************/

export function addEntityArr(entity) {
    entityArr.push(entity)
}

export function clear() {
    for (let i = 0; i < entityArr.length; i++) {
        viewer.entities.remove(entityArr[i]);
    }

    for (let i = 0; i < primitiveArr.length; i++) {
        primitiveArr[i].preUpdateEvent && primitiveArr[i].preUpdateEvent();
        viewer.scene.primitives.remove(primitiveArr[i]);
    }
    primitiveArr = [];
    entityArr = [];

    effectsHelp.clear(); //清楚特效
}

export function formatNum(num, digits) {
    return Number(num.toFixed(digits || 0));
}


export function getCameraView(viewer) {
    viewer = viewer || window.viewer;
    var camera = viewer.camera;
    var position = camera.positionCartographic;
    var bookmark = {};
    bookmark.y = formatNum(Cesium.Math.toDegrees(position.latitude), 6);
    bookmark.x = formatNum(Cesium.Math.toDegrees(position.longitude), 6);
    bookmark.z = formatNum(position.height, 2);
    bookmark.heading = formatNum(Cesium.Math.toDegrees(camera.heading || -90), 1);
    bookmark.pitch = formatNum(Cesium.Math.toDegrees(camera.pitch || 0), 1);
    bookmark.roll = formatNum(Cesium.Math.toDegrees(camera.roll || 0), 1);
    return bookmark;
}



export function action_lineRoam(item) {
    var entity = addGlb(item.data.url, item.coordinate[0]);
    entityArr.push(entity);
    var time = item.data.time;
    var positions = item.coordinate;
    var animation = new PathAnimation({
        entity: entity,
        positions: positions,
        speed: 100,
        sumTime: time,
        multiple: 1,
        height: 0,
        addHeight: 0,
        cameraType: "无",
        shadingType: "无",
        surface: true,
        cycle: false,
    });

    animation.start();
}

export function action_RightAngleArrow(item) {
    var entity = addArrow(item.coordinate);
    entityArr.push(entity);
}

function addArrow(StraightArrowPoints) {
    var polygon = viewer.entities.add({
        name: 'RightAngleArrow',
        polygon: {
            hierarchy: StraightArrowPoints,
            material: Cesium.Color.RED
        }
    });

    return polygon;
}


export function action_pointModel(item) {
    var entity = addGlb(item.data, item.coordinate);
    entityArr.push(entity);
}


export function action_diffusionCircle(item) {
    var entity = addClircle(item.coordinate);
    entityArr.push(entity);
    return entity;
}

import DynamicCircleBMaterialProperty from '../lib/DynamicCircleBMaterialProperty'

function registDynamicCircleBMaterialProperty(Material) {


    Material.DynamicCircleBType = "FingerPrint" + "DynamicCircleB";
    Material._materialCache.addMaterial(Material.DynamicCircleBType, {
        fabric: {
            type: Material.DynamicCircleBType,
            uniforms: {
                color: new Cesium.Color(0.0, 0.0, 1.0, 0.5),
                time: 10,
                count: 2,
                gradient: 0.2
            },
            source: `czm_material czm_getMaterial(czm_materialInput materialInput)
            {
                czm_material material = czm_getDefaultMaterial(materialInput);
                material.diffuse = 1.5 * color.rgb;
                vec2 st = materialInput.st;
                float dis = distance(st, vec2(0.5, 0.5));
                float per = fract(czm_frameNumber * time / 1000.0);
                if(count == 1.0){
                     if(dis > per * 0.5){
                         discard;
                     }else {
                         material.alpha = color.a  * dis / per / 2.0;
                     }
                 } else {
                     vec3 str = materialInput.str;
                     if(abs(str.z)  > 0.001){
                         discard;
                     }
                     if(dis > 0.5){
                         discard;
                     }else {
                         float perDis = 0.5 / count;
                         float disNum;
                         float bl = 0.0;
                         for(int i = 0; i <= 999; i++){
                             if(float(i) <= count){
                                 disNum = perDis * float(i) - dis + per / count;
                                 if(disNum > 0.0){
                                     if(disNum < perDis){
                                         bl = 1.0 - disNum / perDis;
                                     }else if(disNum - perDis < perDis){
                                         bl = 1.0 - abs(1.0 - disNum / perDis);
                                     }
                                     material.alpha = pow(bl,(1.0 + 10.0 * (1.0 - gradient)));
                                 }
                             }
                         }
                     }
                 }
                return material;
            }`,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.DynamicCircleBMaterialPropertyLo = DynamicCircleBMaterialProperty;

}
//添加扩散圆
export function addClircle(position) {
    registDynamicCircleBMaterialProperty(Cesium.Material);
    var material = new Cesium.DynamicCircleBMaterialPropertyLo({
        color: new Cesium.Color(1.0, 0.0, 0.0, 0.8),
        time: 2,
        count: 3,
        gradient: 0.6
    });

    var ellipse = viewer.entities.add({
        position: position,
        ellipse: {
            semiMajorAxis: 200.0,
            semiMinorAxis: 200.0,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            material: material,
            outline: false,
            outlineColor: Cesium.Color.RED,
        },
    });
    return ellipse;
}

//加载glb小模型
export function addGlb(url, position) {
    const entity = viewer.entities.add({
        name: url,
        position: position,
        model: {
            incrementallyLoadTextures: false,
            uri: url,
            minimumPixelSize: 128,
            maximumScale: 20000,
        },
    });

    return entity;
}
//加载着火点
export function addParticleSystem(position) {

    var entity = viewer.entities.add({
        position: position,
    });

    var style = getDefaultStyle();
    var particleSystem = new Cesium.ParticleSystem({
        image: style.fireImage,
        startColor: new Cesium.Color(1, 1, 1, 1),
        endColor: new Cesium.Color(0.5, 0, 0, 0),
        startScale: style.startScale,
        endScale: style.endScale,
        minimumParticleLife: style.minimumParticleLife,
        maximumParticleLife: style.maximumParticleLife,
        minimumSpeed: style.minimumSpeed,
        maximumSpeed: style.maximumSpeed,
        imageSize: new Cesium.Cartesian2(style.particleSize, style.particleSize),
        emissionRate: style.emissionRate,
        lifetime: 16.0,
        loop: true,
        emitter: new Cesium.ConeEmitter(Cesium.Math.toRadians(45.0)),
        sizeInMeters: false,
    });

    viewer.scene.primitives.add(particleSystem);
    var emitterModelMatrix = new Cesium.Matrix4();
    var translation = new Cesium.Cartesian3();
    var rotation = new Cesium.Quaternion();
    var hpr = new Cesium.HeadingPitchRoll();
    var trs = new Cesium.TranslationRotationScale();

    var preUpdateEvent = viewer.scene.preUpdate.addEventListener((scene, time) => {
        particleSystem.modelMatrix = entity.computeModelMatrix(time, new Cesium.Matrix4());
        hpr = Cesium.HeadingPitchRoll.fromDegrees(0.0, 0.0, 0.0, hpr);
        trs.translation = Cesium.Cartesian3.fromElements(0, 0, 0, translation);
        trs.rotation = Cesium.Quaternion.fromHeadingPitchRoll(hpr, rotation);
        particleSystem.emitterModelMatrix = Cesium.Matrix4.fromTranslationRotationScale(trs, emitterModelMatrix);
    });

    particleSystem.preUpdateEvent = preUpdateEvent;
    viewer.scene.primitives.add(particleSystem);
    primitiveArr.push(particleSystem);
    return particleSystem;
}

import { explotEffect } from './explotEffect'
let explotEffectHelp = undefined;
export function addExplotEffect(viewer, entity) {
    explotEffectHelp = new explotEffect(viewer, entity);
}


function getDefaultStyle() {
    return {
        fireImage: "data/img/fire.png",
        // startScale: 3,
        // endScale: 1.5,
        // minimumParticleLife: 1.5,
        // maximumParticleLife: 1.8,
        // minimumSpeed: 7,
        // maximumSpeed: 9,
        // particleSize: 25,
        // emissionRate: 200,
        emissionRate: 5,
        gravity: 0.0,//设置重力参数
        minimumParticleLife: 1,
        maximumParticleLife: 6,
        minimumSpeed: 1.0,//粒子发射的最小速度
        maximumSpeed: 4.0,//粒子发射的最大速度
        startScale: 0.0,
        endScale: 10.0,
        particleSize: 25.0,
    }
}

/**
 * 闪烁特效
 * @param {*} entity 实体
 * @param {*} duration 持续时间
 */
function blinkEntity(entity, duration) {
    var originalShow = entity.show; // 获取实体的原始显示状态

    var blinkEffect = setInterval(function () {
        entity.show = false;
        setTimeout(function () {
            entity.show = true;
        }, 500); // 闪烁间隔为500毫秒
    }, 1000); // 闪烁频率为每秒一次

    // 在持续时间结束后停止闪烁效果
    setTimeout(function () {
        clearInterval(blinkEffect);
        entity.show = originalShow;
    }, duration * 1000);
}


import * as turf from '@turf/turf'

function flattenArray(array) {
    var result = [];

    for (var i = 0; i < array.length; i++) {
        if (Array.isArray(array[i])) {
            result = result.concat(flattenArray(array[i]));
        } else {
            result.push(array[i]);
        }
    }

    return result;
}


/**
 * 增长实体
 * @param {*} entity 
 * @param {*} positions 
 * @param {*} speed 
 * @param {*} height 
 */
function growEntityCom(entity, positions, speed, height = 0) {
    let scale = 0;
    let bbox = [];
    for (var i = 0, len = positions.length; i < len; i++) {
        let cartesian = positions[i];
        var carto = Cesium.Cartographic.fromCartesian(cartesian);
        var x = Cesium.Math.toDegrees(carto.longitude);
        var y = Cesium.Math.toDegrees(carto.latitude);
        let p = [x, y];
        bbox.push(p);
    }
    let callbackProperty = new Cesium.CallbackProperty(() => {

        scale += speed;
        if (scale >= 1) {
            scale = 1;
        }
        //var squared = turf.square(bbox);
        // var poly = turf.bboxPolygon(bbox);
        let polygon = turf.polygon([bbox]);
        let scaledPolygon = turf.transformScale(polygon, scale, {
            origin: [(bbox[0][0] + bbox[1][0]) / 2, (bbox[0][1] + bbox[1][1]) / 2] //sw/se/nw/ne/center/centroid)
        });
        let newPositions = [];
        // 遍历多边形
        for (let i = 0; i < scaledPolygon.geometry.coordinates[0].length; i++) {
            // 遍历节点
            scaledPolygon.geometry.coordinates[0][i].forEach((item) => {
                newPositions.push(item);
            })
            newPositions.push(height);
        }
        let cartesian3Arr = Cesium.Cartesian3.fromDegreesArrayHeights(newPositions);
        var polygonHierarchy = new Cesium.PolygonHierarchy(cartesian3Arr);
        return polygonHierarchy;
    }, false);


    entity.polygon.hierarchy = callbackProperty;

}

function growEntity(entity, positions, speed, height = 0) {
    let scale = 0;
    let bbox = [];

    for (var i = 0, len = positions.length; i < len; i++) {
        let cartesian = positions[i];
        var carto = Cesium.Cartographic.fromCartesian(cartesian);
        var x = Cesium.Math.toDegrees(carto.longitude);
        var y = Cesium.Math.toDegrees(carto.latitude);
        bbox.push(x);
        bbox.push(y);
    }
    let callbackProperty = new Cesium.CallbackProperty(() => {

        scale += speed;
        if (scale >= 1) {
            scale = 1;
        }
        //var squared = turf.square(bbox);
        var poly = turf.bboxPolygon(bbox);
        // let polygon = turf.polygon(positions);
        let scaledPolygon = turf.transformScale(poly, scale, {
            origin: "centroid" //sw/se/nw/ne/center/centroid)
        });
        let newPositions = [];
        // 遍历多边形
        for (let i = 0; i < scaledPolygon.geometry.coordinates[0].length; i++) {
            // 遍历节点
            scaledPolygon.geometry.coordinates[0][i].forEach((item) => {
                newPositions.push(item);
            })
            newPositions.push(height);
        }
        let cartesian3Arr = Cesium.Cartesian3.fromDegreesArrayHeights(newPositions);
        var coordinates = Cesium.Rectangle.fromCartesianArray(cartesian3Arr);
        return coordinates;
    }, false);


    entity.rectangle.coordinates = callbackProperty;

}


/**
* @description: 扩散墙效果（基于turf实现，可以放到或缩小）
* @param {*} _positions：底部坐标，单个面坐标的格式为[[[lon,lat]]]
* @param {*} _scale：最大缩放比例
* @param {*} _height：墙高度
* @param {*} _material：墙材质
* @return {*}
*/
function wallDiffuse(_positions, _scale, _height, _material) {
    let scale = 1;
    this.viewer.entities.add({
        name: "扩散墙",
        wall: {
            positions: new Cesium.CallbackProperty(() => {
                // 判断是放大还是缩小
                if (_scale >= 1) {
                    scale += _scale / 200.0;
                    if (scale >= _scale) {
                        scale = 1.0;
                    }
                } else {
                    scale -= _scale / 200.0;
                    if (scale <= _scale) {
                        scale = 1;
                    }
                }

                let polygon = turf.polygon(_positions);
                let scaledPolygon = turf.transformScale(polygon, scale);
                let newPositions = [];
                // 遍历多边形
                for (let i = 0; i < scaledPolygon.geometry.coordinates[0].length; i++) {
                    // 遍历节点
                    scaledPolygon.geometry.coordinates[0][i].forEach((item) => {
                        newPositions.push(item);
                    })
                    newPositions.push(_height);
                }
                return Cesium.Cartesian3.fromDegreesArrayHeights(newPositions);
            }, false),
            material: _material
        }
    });
}
